export const toggleComplete = (id, value) => {
    return (dispatch, getState, { getFirebase }) => {
        const firebase = getFirebase();
        const firestore = firebase.firestore(); 
        dispatch({ type: "CONTACT_COMPLETE_LOADING", payload: true });
        
        firestore.collection('contacts').doc(id).update({
            isCompleted: value
        })
        .then(() => {
            dispatch({ type: "CONTACT_COMPLETE_SUCCESS" });
            dispatch({ type: "CONTACT_COMPLETE_LOADING", payload: false });
        })
        .catch((err) => {
            dispatch({ type: "CONTACT_COMPLETE_ERROR", error: err });
        });
    };
};

export const setLastContactCreatedTime = (navigationDirection, date) => {
    return (dispatch, getState) => {
        dispatch({ type: "CONTACT_SET_LAST_CONTACT_CREATED_TIME", payload: {
            navigationDirection: navigationDirection,
            date: date
        } });
    };
}